import React from 'react'

import Typography from 'components/atoms/Typography'
import { Container, Table } from 'components/qstrap'

import { scholarships } from './data'

const Scholarships = () => (
  <div id="kit-scholarships" className="kit-scholarships">
    <Container>
      <Typography component="h2" variant="title" className="kit-scholarships__title text-center">
        Beasiswa
      </Typography>
      <Typography component="p" variant="body" className="text-center kit-scholarships__desc">
        Terdapat dua beasiswa yang berpotensi kamu peroleh:
      </Typography>
      <Table className="kit-scholarships__table" striped responsive>
        <thead>
          <tr>
            <th>Program Beasiswa*</th>
            <th>Penjelasan</th>
            <th>Jumlah Beasiswa</th>
          </tr>
        </thead>
        <tbody>
          {
            scholarships.map(sch => (
              <tr key={`scholarship-${sch.id}`}>
                <td>{sch.name}</td>
                <td>{sch.desc}</td>
                <td>{sch.value}</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
      <Typography component="p" variant="subheadline" className="kit-scholarships__note">
        *Program beasiswa diberikan pada mahasiswa Jurusan Software Engineering
      </Typography>
      <Typography component="p" variant="body" className="kit-scholarships__schema">
        Ada skema yang unik nih Quipperian, dari kedua program beasiswa yang disediakan oleh KIT Cambodia. Kamu akan menerima uang beasiswa tersebut pada saat kamu lulus kuliah, sehingga semua mahasiswa di kampus ini memiliki kesempatan untuk mendapatkan beasiswa tersebut. Jadi, yang terpenting adalah terus konsisten dan rajin dalam belajar ya!
      </Typography>
    </Container>
  </div>
)

export default Scholarships
